import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, startWith, switchMap } from 'rxjs/operators';
import { AutoCompleteComponent } from '@components/dynamic-form/auto-complete/auto-complete.component';
import { AutocompleteControl } from '@components/dynamic-form/auto-complete/autocomplete-control';
import { TestDriveService } from '@services/test-drive.service';
import { ClienteSearchModel } from '@/models/test-drive/cliente-search.model';
import { LoggerService } from '@services/logger.service';
import { Registry } from '@/registry.service';

@Component({
  selector: 'app-auto-complete-cliente',
  templateUrl: '../../auto-complete.component.html',
  styleUrls: ['../../auto-complete.component.scss'],
})
export class AutoCompleteClienteComponent extends AutoCompleteComponent implements OnInit {
  @Input() meta!: AutocompleteControl;
  @Input() form!: FormGroup;
  @Input() indexRow: number = null;
  @Input() keyformArrayName: any;
  control = new FormControl('');
  filteredOptions: Observable<ClienteSearchModel[]>;

  constructor(private testDriveService: TestDriveService) {
    super();
  }

  ngOnInit(): void {
    this.setControl();

    this.filteredOptions = this.control.valueChanges.pipe(
      startWith(''),
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((value) => {
        // Se il valore è un oggetto (selezione), non fare chiamata API
        if (value && typeof value === 'object' && !Array.isArray(value)) {
          return of([]);
        }
        // Se è una stringa, estrai il termine di ricerca
        const searchTerm = typeof value === 'string' ? value : this.getValue(value);
        if (!searchTerm || searchTerm.length < 3) {
          return of([]);
        }
        return this.testDriveService.searchCliente(searchTerm);
      }),
    );
  }

  displayFn(selectedOption: any): string {
    if (!selectedOption) {
      return '';
    }
    if (typeof selectedOption === 'string') {
      return selectedOption;
    }
    const cliente = selectedOption as ClienteSearchModel;
    const denominazione = cliente.denominazione || '';
    const codiceFiscale = cliente.codiceFiscale || '';

    if (codiceFiscale) {
      return `${denominazione} - CF. ${codiceFiscale}`;
    }
    return denominazione;
  }

  protected getValue(obj: any): string {
    if (!obj) {
      return '';
    }
    if (typeof obj === 'string') {
      return obj;
    }
    const cliente = obj as ClienteSearchModel;
    const denominazione = cliente.denominazione || '';
    const codiceFiscale = cliente.codiceFiscale || '';

    if (codiceFiscale) {
      return `${denominazione} - CF. ${codiceFiscale}`;
    }
    return denominazione;
  }

  protected customActionInput(event, indexRow = null) {
    LoggerService.log('Cliente Selected!');

    if (
      this.meta.classToUse &&
      this.meta.customAction &&
      Registry.getInstance().get(this.meta.classToUse) &&
      Registry.getInstance().get(this.meta.classToUse)[this.meta.customAction]
    ) {
      Registry.getInstance()
        .get(this.meta.classToUse)
        [this.meta.customAction](event.option.value, indexRow);
    } else {
      LoggerService.log('Cliente selection function not found');
    }
  }
}
